import { render, staticRenderFns } from "./ServiceProviderLawyersOfficesCard.vue?vue&type=template&id=5e9a2cdc&scoped=true"
import script from "./ServiceProviderLawyersOfficesCard.vue?vue&type=script&lang=js"
export * from "./ServiceProviderLawyersOfficesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9a2cdc",
  null
  
)

export default component.exports